import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CallIcon from '@mui/icons-material/Call';
import MessageIcon from '@mui/icons-material/Message';
import EventAvailable from '@mui/icons-material/EventAvailable';
import RocketChatWidget from '../../../Chatbot/RocketChatWidget';
import colors from '../../../../utils/colors';
import { withStyles } from '@mui/styles';
import CallDialog from '../../../dynamicHome/components/VideoCard/CallPopup ';

const styles = {
  heading: {
    fontFamily: 'Inter',
    fontSize: 18,
    fontWeight: 600,
    color: colors.WHITE,
  },
  rows: { fontFamily: 'Inter', fontSize: '16px', fontWeight: 500, color: colors.BLACK },
};

const TABLE_HEADING = ['Name', 'Role', 'Type', 'Action'];

const CareTeamTableGrid = ({ data, classes }) => {
  const navigate = useNavigate();
  const [callDialogOpen, setCallDialogOpen] = React.useState(false);
  const [selectedMember, setSelectedMember] = React.useState(null);

  const handleNavigate = (link) => {
    navigate(link); 
  };

  const handleMessageIconClick = (member_name) => {
    window.dispatchEvent(
      new CustomEvent('openChat', { detail: { member_name } })
    );
  };

  const handleCallIconClick = (member) => {
    setSelectedMember({
      name: member.member_name,
      role: member.specialty,
      phone: member.phone || member.member_id // Adjust based on your data structure
    });
    setCallDialogOpen(true);
  };

  const handleCloseCallDialog = () => {
    setCallDialogOpen(false);
    setSelectedMember(null);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 640 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {TABLE_HEADING.map((heading) => (
                <TableCell
                  sx={{
                    fontFamily: 'Inter',
                    fontSize: 18,
                    fontWeight: 600,
                    color: colors.BLACK,
                  }}
                  key={heading}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" className={classes.rows}>
                  {row.member_name}
                </TableCell>
                <TableCell align="left" className={classes.rows}>
                  {row.specialty}
                </TableCell>
                <TableCell align="left" className={classes.rows}>
                  {row.partnerName}
                </TableCell>
                <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                    <CallIcon
                      color="primary"
                      sx={{ marginRight: '16px', cursor: 'pointer' }}
                      onClick={() => handleCallIconClick(row)}
                    />
                    <MessageIcon
                      color="primary"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleMessageIconClick(row.member_name)}
                    />
                    <EventAvailable
                      color="secondary"
                      sx={{ marginLeft: '16px', cursor: 'pointer' }}
                      onClick={() => handleNavigate('/records/new/appointments')}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Call Dialog for the selected member */}
      {selectedMember && (
        <CallDialog
          open={callDialogOpen}
          onClose={handleCloseCallDialog}
          careTeam={[selectedMember]} // Pass the selected member as an array
        />
      )}
    </>
  );
};

export default withStyles(styles, { withTheme: true })(CareTeamTableGrid);